import {
  HyperlinkVariable,
  MapVariable,
  NumStringVariable,
} from "../textInterfaces";

export const isHyperlinkVariable = (value: any): value is HyperlinkVariable => {
  return "__type" in value ? value.__type === "hyperlink" : false;
};

export const isMapVariable = (value: any): value is MapVariable => {
  return "__type" in value ? value.__type === "map" : false;
};

export const isNumStringVariable = (value: any): value is NumStringVariable => {
  if (typeof value === "string" || typeof value === "number") {
    return false;
  }
  return "__type" in value
    ? value.__type === "string" || value.__type === "number"
    : false;
};
